(() => {
  const init = () => {
    initPageMv();
    initPageDisp();
  };
  const resize = () => {
    initPageMv();
    initPageDisp();
  };
  const scroll = () => {
    initPageDisp();
  }

  // EventListener
  window.addEventListener("DOMContentLoaded", init);
  window.addEventListener('resize', resize);
  window.addEventListener("scroll", scroll);

})();

// MV要素にheaderと同じ高さのマージンをセット
const initPageMv = () => {
  const headerH = document.getElementById("header").clientHeight;
  const pageMv = document.querySelector(".page-mv");

  pageMv.style.marginTop = headerH + "px";
}

// 円形に広がりながらページ表示
const initPageDisp = () => {
  const page = document.querySelector(".page");

  const updateCircleCenter = () => {
    // ビューポートの幅と高さ
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    // スクロール位置
    const scrollTop = window.scrollY;
    // 中心座標
    const centerX = viewportWidth / 2 + "px";
    const centerY = scrollTop + viewportHeight / 2 + "px";

    // CSSカスタムプロパティに設定
    document.documentElement.style.setProperty("--circle-center-x", centerX);
    document.documentElement.style.setProperty("--circle-center-y", centerY);
  };

  // 初期設定
  updateCircleCenter();

  // ページのアニメーションを発動
  setTimeout(() => {
    page.classList.add("is-on");
  }, 1000);
}